import React from "react";
import { getDsLayoutComponentRenderer } from "@kaltura/mediaspace-shared-layout";

const PersonalProfile = React.lazy(() => import("@mediaspace/features/personal-profile/PersonalProfile"));
const WatchlistTab = React.lazy(() => import("@mediaspace/features/personal-profile/watchlist-tab/WatchlistTab"));
const ScheduledWatchlistTab = React.lazy(
    () => import("@mediaspace/features/personal-profile/scheduled-watchlist-tab/ScheduledWatchlistTab")
);
const CalendarTab = React.lazy(() => import("@mediaspace/features/personal-profile/calendar-tab/CalendarTab"));

const RsvpTab = React.lazy(() => import("@mediaspace/features/personal-profile/rsvp-tab/RsvpTab"));

export const render = getDsLayoutComponentRenderer(PersonalProfile);

export { WatchlistTab, ScheduledWatchlistTab, CalendarTab, RsvpTab };

export { BadgesTab } from "@kaltura/mediaspace-shared-user-badges";
